import config from 'config';
import { trackEvent, TRACK_EVENT } from '../utils/analytics';
import utils from './utils';

export const openWhatsappToUrl = (message: string, url: string = config.whatsappUrl) => {
    // NB: the preview message on web whatsapp appears without new lines but
    //     if you continue the message in the chat appears with new lines
    message = window.encodeURIComponent(message);
    return utils.handleRedirectionUrl(`${url}${message}`);
};

//
// open whatsapp chat to Taffi with message
//
export const openWhatsapp = (message: string, eventParams?: any) => {
    if (eventParams) {
        trackEvent(TRACK_EVENT.WHATSAPP_CONTACT, eventParams);
    }
    openWhatsappToUrl(`${message}`, config.taffiWhatsappUrl);
};

export const sendWhatsappMessageToNumber = (message: string, number: string, eventParams?: any) => {
    if (eventParams) {
        trackEvent(TRACK_EVENT.WHATSAPP_CONTACT, eventParams);
    }
    message = window.encodeURIComponent(message);
    return window.open(`${config.whatsAppHost}${number}?text=${message}`, '_blank');
};

export const getConsultStylistWAMessage = ({ userDetail, item, user, styleTaffiId, isItemOnly = false }) => {
    const fn = userDetail?.firstName;
    const type = item?.collection === 'styles' ? 'style' : 'item';
    const taffiId = item?.collection === 'styles' ? item.taffiId : item.data.taffiId;
    const msg = `Hello Taffi,\n\nI need to consult the stylist ${
        user?.firstName + ' ' + user?.lastName
    } about the ${type}.
        \n${
    type === 'style'
        ? utils.getShareEntityUrl('/style', styleTaffiId)
        : isItemOnly
            ? utils.getShareEntityUrl('/item', taffiId)
            : utils.getShareEntityUrlWithParams('/item', taffiId, `styleTaffiId=${styleTaffiId}`, styleTaffiId)
}\n\n- ${fn}`;
    return msg;
};
